export const FinalMenu = [
  {
    category: {
      item: [{}],
    },
  },
];

// export const MyCart = []

export class MyCart {
  static shared = MyCart.shared || new MyCart();

  _itemArray = [];

  getCartItems() {
    return this._itemArray;
  }

  setMenuArray(menuArray) {
    this._itemArray = [];
  }

  pushToCart(item) {
    this._itemArray.push(item);
    console.log(this._itemArray);
  }

  getCartSubTotal() {
    let total = 0.0;
    for (let i = 0; i < this._itemArray.length; i++) {
      total = total + this._itemArray[i].price;
    }
    return Math.round((total + Number.EPSILON) * 100) / 100;
  }

  getCartTaxesFees() {
    const taxRate = 0.08;
    let subTotal = this.getCartSubTotal();
    let x = taxRate * subTotal;
    return Math.round((x + Number.EPSILON) * 100) / 100;
  }

  getCartTotal() {
    let subTotal = this.getCartSubTotal();
    let taxesFees = this.getCartTaxesFees();
    let x = subTotal + taxesFees;
    return Math.round((x + Number.EPSILON) * 100) / 100;
  }
}

export const Constant = {
  font: "HelveticaNeue",
  gray: "#ebebeb",
  treeGreen: "#2BAE66FF",
  color1: "#00A8E1", //#d50035 #ee003b
  color2: "#00cc48",
  backgroundColor: "#fcfcfc",
  backgroundColor2: "#f4f4f4",

  stripePublicKey:
    "pk_test_51H7XFvJB6x3gXxqhOlX80i2u7S48z1TO7eRBvHaqNl5bDDNxSNPhhm3IrPmHkBBOn4qtlusSnf1IsuEHImwFgWR500mZ8uQC34",

  flyByFee: 0.02,
};
